import { environment } from '../../../../environments/environment'

export const auth0Config = {
    ...environment.auth0Config
}